import React from "react";
import { Home, Settings } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from "@/lib/utils";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.startsWith('/settingspage') ? 'settings' : 'home';

  return (
    <footer className="jr-bottom-nav">
      <button
        type="button"
        className={cn("jr-bottom-nav-item", activeTab === 'home' && "is-active")}
        onClick={() => navigate('/chatlistpage')}
        aria-current={activeTab === 'home' ? 'page' : undefined}
      >
        <span className="jr-bottom-nav-icon" aria-hidden="true">
          <Home size={20} />
        </span>
        <span className="jr-bottom-nav-label">Home</span>
      </button>

      <button
        type="button"
        className={cn("jr-bottom-nav-item", activeTab === 'settings' && "is-active")}
        onClick={() => navigate('/settingspage')}
        aria-current={activeTab === 'settings' ? 'page' : undefined}
      >
        <span className="jr-bottom-nav-icon" aria-hidden="true">
          <Settings size={20} />
        </span>
        <span className="jr-bottom-nav-label">Settings</span>
      </button>
    </footer>
  );
}
